import { useSelector } from "react-redux"
import styled from "styled-components"
import InputText from "../../../shared/input/new/InputText"
import InputSelect from "../../../shared/input/new/InputSelect"
import { useEffect, useRef, useState } from "react"
import MessageFileInput from "../../../shared/input/special/MessageFileInput"
import Btn from "../../../shared/button/Btn"
import { useDispatch } from "react-redux"
import { Editor } from "@tinymce/tinymce-react";
import { createBlogContent } from "../../../../features/admin3/admin3Slice"
import { FaRegTrashAlt } from "react-icons/fa";


const Container = styled.div`
    height: 100%;
    width: 100%;
    .border{
        border-top: 3px solid ${({theme}) => theme.mainBorderColor};
    }
    .title{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-lg);
        color: var(--color-main);
        padding: 25px 25px 0px 25px;
    }
    .blog-container{
        height: calc(100% - 120px);
        width: 100%;
        max-height: 400000px !important;
        overflow: auto;
        padding: 25px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .col{
            display: flex;
            flex-direction: column;
            gap: 5px;
            .error{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: var(--color-main) !important;
            }
        }
        .img-container{
            display: flex;
            align-items: center;
            gap: 20px;
            .delete{
                cursor: pointer;
                background-color: var(--color-main);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
                svg{
                    color: #fff;
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    .tox-statusbar__branding {
        display: none !important;
    }
`
const positionData = [
    {
      id:1,
      text:"Alt",
      value: true
    },
    {
      id:2,
      text:"Üst",
      value: false
    }
  ]

const UpdateBlogNewContentSide = () => {
    const dispatch = useDispatch()
    const {selectedBlog} = useSelector((state) => state.admin3)
    const [isSubmitting, setIsSubmitting] = useState(false)

    // editor api key: 2qmpv32qpo25r12qss3ev9fso6rpl34gor5hrb38ptieiowi
    const [imagePosition, setImagePosition] = useState(null)
    const [listAndDetailImage, setListAndDetailImage] = useState(null)
    
    const [listData, setListData] = useState({
        mainTitle: "",
        mainImageAlt: "",
        content: "",
    })

    const handleChange = (e) => {
        setListData({...listData, [e.target.name]: e.target.value})
    }

    const handleEditorChange = (content) => {
        setListData({ ...listData, content }); // Editor içeriğini güncelle
    };

    const handleCreateBlogList = () => {
        setIsSubmitting(true)

        if (listAndDetailImage && !listData.mainImageAlt) {
            return;
        }

        if(listData.content) {
            const formData = new FormData()
            formData.append("mainTitle", listData.mainTitle || "")
            formData.append("main", listData.content)
            formData.append("mainImage", listAndDetailImage)
            formData.append("mainImageAlt", listData.mainImageAlt || "")
            formData.append("mainImagePosition", imagePosition?.value || true)
            formData.append("blogId", selectedBlog?.id)
    
            dispatch(createBlogContent(formData))
            setListData({
                mainTitle: "",
                mainImageAlt: "",
                content: "",
            })
            setImagePosition(null)
            setListAndDetailImage(null)
        }
        
    }

  return (

    <Container>
        <div className="title">Yeni İçerik Ekle</div>
        <div className="blog-container">
            <InputText inputWidth={"100%"} data={listData.mainTitle} setData={(e) => handleChange(e)} name={"mainTitle"} labelText={"Ana Başlık"} />
            <div className="col">
                <Editor
                    apiKey="4b0bsl6u6sv8iqg9bh7giddxo16ulrl9whc4cmz46j7dsirn" // API anahtarınızı buraya koyun
                    value={listData.content}
                    init={{
                        height: 500,
                        menubar: "format",
                        menu: {
                            format: { title: "Format", items: "bold underline blocks | removeformat" },
                        },
                        plugins: [ 
                            "link", "lists",
                            "advlist", "autolink", "charmap", "print", "preview", "anchor",
                            "searchreplace", "fullscreen",
                            "insertdatetime", "paste", "help", "wordcount", 
                        ],
                        toolbar:
                            "undo redo | formatselect | bold | \
                            bullist numlist outdent indent | link removeformat | help",
                    }}
                    onEditorChange={handleEditorChange}
                />
                {isSubmitting && !listData.content &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>
            <div className="img-container">
                <MessageFileInput setSelectedFile={setListAndDetailImage} />
                <div className="delete" onClick={() => listAndDetailImage(null)}>
                    <FaRegTrashAlt />
                </div>
                
                <InputText inputWidth={"100%"} data={listAndDetailImage?.name} disabled={true} setData={(e) => handleChange(e)} name={"listAndDetailImage"} labelText={"Bloglar Listesi Görseli ve Detay Sayfası Ana Görsel"} />
            </div>
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.mainImageAlt} setData={(e) => handleChange(e)} name={"mainImageAlt"} labelText={"Alt Etiketi"} />
                {isSubmitting && !listData.mainImageAlt && listAndDetailImage &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>
            <InputSelect initialOptions={positionData} inputWidth={"100%"} data={imagePosition?.text} setData={setImagePosition} name={"positionData"} labelText={"Görsel Konumu"} />
            <div className="btn-container">
                <Btn width={"200px"} color="#E85446" bgColor="transparent" padding="0 10px" handleClick={handleCreateBlogList} >Ekle</Btn>
            </div>
        </div>
         
    </Container>
  )
}

export default UpdateBlogNewContentSide